import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { RumComponentContextProvider } from '@mint-lib/datadog';
import { Outlet } from '@mint/routing';

export default function ApprovalV2Root() {
  return (
    <RumComponentContextProvider componentArea="approval-flow">
      <Outlet />
      <ReactQueryDevtools initialIsOpen={false} />
    </RumComponentContextProvider>
  );
}
